var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('OnRatiosEmploisAgency',{attrs:{"agencyId":_vm.f_agency_id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }